import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import styles from '../../../Products.module.scss'

// import { getNormalizedPrice } from 'utils/functions'
import { ServiceActionsTypes } from 'store/service/actions'
import { selectProxyCheckerLoading } from 'store/service/selectors'

import {
  Check as CheckIcon,
  BookOpen as BookIcon,
  Server as ServerIcon,
} from '../../../../../icons'
// import ProductPricingBlock from 'components/elements/blocks/ProductPricingBlock'
import TabsList from 'components/elements/tabs/TabsList'
import CurlResult from './CurlResult'
import CredentialsResult from './CredentialsResult'
import UrlResult from './UrlResult'
import TabPanels from 'components/elements/tabs/TabPanels'
import Accordion from 'components/elements/blocks/Accordion'
import InputGroup from 'components/elements/forms/InputGroup'
import CustomRadio from 'components/elements/inputs/CustomRadio'
import ProxyCheckerSingleResult from '../../ProxyCheckerSingleResult'

import { IProxyPackage } from '../../../../../../models/user'
/*import {
  selectProductPrice,
  selectProductPriceFetching,
} from 'store/pricing/selectors'
import {
  selectAvailableHosts,
  selectUserSubscriptionView,
} from 'store/user/selectors'*/
import { ISelectOption } from 'components/elements/inputs/CustomSelect/CustomSelect'

interface IProxyConnectResultProps {
  selectedProxyType: any
  selectedPackage: IProxyPackage
  urlResultString: string
  credResultString: string
  curlResultString: string
  selectedSpaceSymbol: string
  selectedAmpersandSymbol: string
  selectedHostValue: string
  activeSessionLengthType: any
  selectedOutputMask: ISelectOption
  onSpaceSymbolChange: (value: string) => void
  onAmpersandSymbolChange: (value: string) => void
  onOutputMaskChange: (option: ISelectOption) => void
  onGenerateIpClick: () => void
}

const ProxyQuickResult: React.FC<IProxyConnectResultProps> = (props) => {
  const {
    /*selectedProxyType,*/
    selectedPackage,
    urlResultString,
    credResultString,
    curlResultString,
    selectedSpaceSymbol,
    selectedAmpersandSymbol,
    selectedHostValue,
    selectedOutputMask,
    activeSessionLengthType,
    onOutputMaskChange,
    onSpaceSymbolChange,
    onAmpersandSymbolChange,
    onGenerateIpClick,
  } = props

  const tabItems = [
    {
      label: 'Username & password',
    },
    {
      label: 'URL',
    },
    {
      label: 'cURL request',
    },
  ]

  const dispatch = useDispatch()

  const [selectedResultTypeIndex, setSelectedResultTypeIndex] = useState(0)

  // const availableHosts = useSelector(selectAvailableHosts)
  // const subscriptionInfo = useSelector(selectUserSubscriptionView)

  // const isDemoModeAvailable = !subscriptionInfo?.status

  // const productPrice = useSelector(selectProductPrice)
  // const productPriceFetching = useSelector(selectProductPriceFetching)

  /*const getProductName = () => {
    if (selectedProxyType && selectedProxyType.shortLabel) {
      return `Proxy: ${selectedProxyType.shortLabel} pool`
    } else {
      return ''
    }
  }*/

  // const productName = getProductName()

  // const normalizedPrice = getNormalizedPrice(productPrice)

  // const productPriceString = productPrice ? `$${normalizedPrice} per 1 GB` : ''

  const handleResultTypeChange = (index: number) => {
    setSelectedResultTypeIndex(index)
  }

  const handleSpaceSymbolChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSpaceSymbolChange(e.target.value)
  }

  const handleAmpersandSymbolChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    onAmpersandSymbolChange(e.target.value)
  }

  const handleCheckProxyConnection = () => {
    dispatch({
      type: ServiceActionsTypes.SERVICE_CHECK_PROXY,
      proxies: [urlResultString],
    })
  }

  const credPassword = selectedPackage.package_key
  const credPort = '5000'

  const tabContentArray = [
    <CredentialsResult
      login={credResultString}
      password={credPassword}
      server={selectedHostValue}
      port={credPort}
      activeSessionLengthType={activeSessionLengthType}
      onGenerateIpClick={onGenerateIpClick}
      onCheckProxyConnection={handleCheckProxyConnection}
    />,
    <UrlResult
      result={urlResultString}
      selectedOutputMask={selectedOutputMask}
      activeSessionLengthType={activeSessionLengthType}
      onOutputMaskChange={onOutputMaskChange}
      onGenerateIpClick={onGenerateIpClick}
      onCheckProxyConnection={handleCheckProxyConnection}
    />,
    <CurlResult
      result={curlResultString}
      activeSessionLengthType={activeSessionLengthType}
      onGenerateIpClick={onGenerateIpClick}
      onCheckProxyConnection={handleCheckProxyConnection}
    />,
  ]

  const guideLinksArray = [
    <a
      className={styles.guideLink}
      href="https://helpcenter.soax.com/en/collections/3146082-software-tutorials"
      target={'_blank'}
      rel={'noopener noreferrer'}
    >
      <div className={styles.bookIconWrapper}>
        <BookIcon />
      </div>{' '}
      <span>Need help with setting up your browser, plugin or app?</span>
    </a>,
    <a
      className={styles.guideLink}
      href="https://helpcenter.soax.com/en/collections/3146082-software-tutorials"
      target={'_blank'}
      rel={'noopener noreferrer'}
    >
      <div className={styles.bookIconWrapper}>
        <BookIcon />
      </div>{' '}
      <span>Need help with setting up your browser, plugin or app?</span>
    </a>,
    <a
      className={styles.guideLink}
      href="https://helpcenter.soax.com/en/articles/10125344-proxy-set-up-using-curl-php-net-with-c-or-python-beta"
      target={'_blank'}
      rel={'noopener noreferrer'}
    >
      <div className={styles.bookIconWrapper}>
        <BookIcon />
      </div>{' '}
      <span>How to set up proxies using CURL, PHP, .NET, C# or Python</span>
    </a>,
  ]

  const renderGuideLink = () => {
    return guideLinksArray[selectedResultTypeIndex]
  }

  return (
    <div className={styles.blockMain}>
      <div
        className={`
          ${styles.blockBackgroundHeader}
        `}
      >
        <div>
          <div className={styles.headerIconWrapper}>
            <ServerIcon />
          </div>

          <span className={styles.blockTitle}>Proxy credentials</span>
        </div>

        <div className={styles.headerCheck}>
          <div className={styles.checkIconWrapper}>
            <CheckIcon />
          </div>
          Updated
        </div>
      </div>

      {/*<ProductPricingBlock
        className={styles.pricingBlock}
        product={productName}
        price={productPriceString}
        loading={productPriceFetching}
      />*/}

      <div className={styles.resultContent}>
        <InputGroup labelTop={'Connection method'} boldLabel>
          <div className={styles.groupInnerBlock} />
        </InputGroup>

        <div className={styles.resultTabsWrapper}>
          <TabsList
            items={tabItems}
            type={'bordered'}
            onChange={handleResultTypeChange}
            activeTabIndex={selectedResultTypeIndex}
            className={styles.resultTabs}
          />
        </div>

        <TabPanels
          className={styles.resultMain}
          items={tabContentArray}
          activeTabIndex={selectedResultTypeIndex}
        />

        <ProxyCheckerSingleResult />

        <div
          className={`${selectedResultTypeIndex === 2 ? styles.hidden : ''}`}
        >
          <Accordion
            title={'Advanced output options'}
            className={styles.optionsAccordion}
          >
            <div className={styles.advancedOptions}>
              <InputGroup
                labelTop={'Replace space symbol in location options with:'}
                boldLabel
                className={styles.advancedOptionsInputGroup}
              >
                <CustomRadio
                  id={'+_space-radio'}
                  name={'space-symbol'}
                  value={'+'}
                  checked={selectedSpaceSymbol === '+'}
                  onChange={handleSpaceSymbolChange}
                  className={styles.radio}
                >
                  +
                </CustomRadio>
                <CustomRadio
                  id={'__space-radio'}
                  name={'space-symbol'}
                  value={'_'}
                  checked={selectedSpaceSymbol === '_'}
                  onChange={handleSpaceSymbolChange}
                  className={styles.radio}
                >
                  _
                </CustomRadio>
                <CustomRadio
                  id={'%20_space-radio'}
                  name={'space-symbol'}
                  value={'%20'}
                  checked={selectedSpaceSymbol === '%20'}
                  onChange={handleSpaceSymbolChange}
                  className={styles.radio}
                >
                  %20
                </CustomRadio>
              </InputGroup>

              <InputGroup
                labelTop={'Replace “&” symbol in location options with:'}
                boldLabel
                className={styles.advancedOptionsInputGroup}
              >
                <CustomRadio
                  id={'quick-result_default_ampersand-radio'}
                  name={'quick-result_ampersand-symbol'}
                  value={'&'}
                  checked={selectedAmpersandSymbol === '&'}
                  onChange={handleAmpersandSymbolChange}
                  className={styles.radio}
                >
                  don't replace
                </CustomRadio>
                <CustomRadio
                  id={'quick-result_%26_ampersand-radio'}
                  name={'quick-result_ampersand-symbol'}
                  value={'%26'}
                  checked={selectedAmpersandSymbol === '%26'}
                  onChange={handleAmpersandSymbolChange}
                  className={styles.radio}
                >
                  %26
                </CustomRadio>
              </InputGroup>
            </div>
          </Accordion>
        </div>

        {renderGuideLink()}
      </div>
    </div>
  )
}

export default ProxyQuickResult
